<template>
  <div id="page-wrapper">
    <div id="page">
      <app-header></app-header>
      <div class="page-body">
        <app-navbar></app-navbar>
        <div class="main-page-content  ml-0">
          <div id="main-wrapper" class="layout-main-wrapper clearfix">
            <div id="main" class="container-fluid ml-0">
              <div class="row row-offcanvas row-offcanvas-left clearfix">
                <main class="main-content col content-full-width" id="content" role="main">
                  <section id="vitamin-summary" class="section vitamins mb-5">
                    <div class="row">
                      <div id="summary-current-score" class="col-md-12">
                        <div class="col-card">
                          <div class="row">
                            <div class="col-md-12 mb-4">
                              <div>
                                <generic-chart v-if="submittedSubscores.length && vitaminLabels.length"
                                               style="height: 40vh"
                                               :name="'Subscores'"
                                               :type="'radar'"
                                               :set-labels="['Current','Previous']"
                                               :chart-labels="vitaminLabels"
                                               :chart-data="[submittedSubscores,reviewedSubscores]">
                                </generic-chart>
                              </div>
                            </div>
                            <div class="col-md-4">
                              <div class="label-centered">{{ $t('message.team_average') }}</div>
                              <div class="score score-medium score-medium-three"
                                   :class="team ? ('score-c-'+truncate(team.vipscore,0)+' score-bc-'+truncate(team.vipscore,0)) : null">
                                <div :class="team ? (team.vipscore % 1 > 0 ? 'small-score' : '') : ''"
                                     class="content">
                                  {{team ? truncate(team.vipscore,1) : '--'}}
                                </div>
                              </div>
                            </div>
                            <div class="col-md-4">
                              <div class="label-centered">{{ $t('message.current_score') }}</div>
                              <div class="score score-medium score-medium-three"
                                   :class="lastSubmitted ? ('score-c-'+truncate(lastSubmitted.vipscore,0)+' score-bc-'+truncate(lastSubmitted.vipscore,0)) : null">
                                <div :class="lastSubmitted ? (lastSubmitted.vipscore % 1 > 0 ? 'small-score' : '') : ''"
                                     class="content">
                                  {{lastSubmitted ? truncate(lastSubmitted.vipscore,1) : '--'}}
                                </div>
                              </div>
                            </div>
                            <div class="col-md-4">
                              <div class="label-centered">{{ $t('message.company_average') }}</div>
                              <div class="score score-medium score-medium-three"
                                   :class="company ? ('score-c-'+truncate(company.vipscore,0)+' score-bc-'+truncate(company.vipscore,0)) : null">
                                <div :class="company ? (company.vipscore % 1 > 0 ? 'small-score' : '') : ''"
                                     class="content">{{company ? truncate(company.vipscore,1) : '--'}}
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>

                    <nav class="tabnav tab-nav mb-0">
                      <template v-for="(step,ind) in steps">
                        <button
                          :class="(ind === activeStep ? 'active' : '')"
                          @click.stop.prevent="activeStep = ind"
                          class=" btn-link btn tab-link">
                          {{step.title}}
                        </button>
                      </template>
                    </nav>
                    <div style="min-height:30vh" :class="showPrevious ? 'previous-reviewed' : ''"
                         id="accordion-summary">
                      <template v-for="(step,ind) in steps">
                        <step class="tab-content"
                              :review="true"
                              :index="ind"
                              :submittedAnswers="submittedAnswers"
                              :previousAnswers="previousAnswers"
                              v-show="activeStep === ind"
                              :step="step"></step>
                        <!--   -->
                      </template>
                    </div>
                    <button v-if="(lastSubmitted ? (lastSubmitted.status === 'final') : false) && role === 'user'"
                            class="ml-auto d-block btn-primary button btn" @click="submitReview">
                      {{ $t('message.submit') }}
                    </button>
                  </section>
                </main>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>


</template>

<script>
  import Progress from "../Vitamins/Progress";
  import Step from "../Vitamins/Step";
  // import axios from '../../axios-auth';
  import Header from "../Header";
  import Nav from "../Nav";
  import store from "../../store/store";
  import GenericChart from "../Charts/GenericChart";

  export default {
    components: {
      GenericChart,
      appHeader: Header,
      appNavbar: Nav,
      progressInd: Progress,
      Step
    },
    created() {
      this.unsubscribe = store.subscribe((mutation, state) => {
        if (mutation.type === 'setLang') {
          this.loadData();
        }
      });

      let uid = store.getters.getUserId;
      if (this.$route.params.uid) {
        uid = this.$route.params.uid;
      }

      this.loadTeam(uid);
      this.loadCompany();

      this.role = store.state.viewMode;
      store.commit('resetVitaminData');
      this.loadData();
      this.getVitamins();

    },
    data() {
      return { //todo use getters to get draft and previous from store
        company: {},
        activeStep: 0,
        vitamins: [],
        team: {},
        store: store,
        role: null,
        startRender: 0,
        lastSubmitted: null,
        lastReviewed: null,
        steps: [], //steps = vitamins, which contain subcategories, which contain questions
        showPrevious: false, // toggle to highlight last final submission answers,
        comments: [],
        index: this.$route.params.index,
        submittedLabels: [],
        reviewedLabels: [],
        submittedSubscores: [],
        reviewedSubscores: [],
        vitamins: [],
      }
    },
    computed: {
      vitaminLabels() {
        const labels = [];
        if (this.vitamins) {
          this.vitamins.forEach(vitamin => {
            labels.push(this.localizedField(vitamin,'Title'))
          });
        }
        return labels
      },
      submittedAnswers() {
        return store.getters.getSubmittedAnswers
      },
      previousAnswers() {
        return store.getters.getPreviousAnswers
      },

      getCommentCount() {
        return this.comments.length + this.commentCount
      },
      commentCount() {
        return store.getters.getCommentCount;
      },
      submitted() {
        return store.state.vitaminFormData.submitted;
      }
    },


    methods: {
      async getVitamins() {
        const vitamins = await this.axios.get('/vitamines?published=1&_sort=sort:ASC');
        this.vitamins = vitamins.data;
        this.vitaminScores = {};
        this.vitamins.forEach(vitamin => {
          this.vitaminScores[vitamin.id] = []
        })
      },
      async getSubscores(submission, type) {
        let vitaminScores = [];
        if (submission.data) {
          vitaminScores = submission.data.children;
        }


        if (type === 'submitted') {
          this.submittedSubscores = [];
          vitaminScores.forEach(vitamin => {
            this.submittedSubscores.push(vitamin.average)
          });
        }
        if (type === 'reviewed') {
          this.reviewedSubscores = [];
          vitaminScores.forEach(vitamin => {
            this.reviewedSubscores.push(vitamin.average)
          });
        }
      },
      loadData() {
        let vm = this;
        this.getQuestions().then(resp => {
            const steps = resp.data; // steps are component data, submission data is stored in state
            this.fillSteps(steps); // fill steps and questions with data from server
            this.loadSubmissionData()
            this.loadPreviousData()

          }
        );
      },
      vitaminScore(vitamin_id, submission) {
        let score = 0;
        submission.subscores.forEach(subscore => {
          if (subscore.vitamine === vitamin_id) {
            return subscore.average
          }
        });
        return score;
      },
      async getQuestions() {
        return await this.axios.get('/questions/order?lang=' + store.getters.getLang)
      },
      loadTeam(uid) {
        const teams = [];
        this.axios.get('/users/' + uid).then(res => {
          const user = res.data;
          user.teams.forEach(val => {
            teams.push(val);
            this.team = teams[0]
          })
        })
      },
      loadCompany() {
        const company = store.getters.getCompany
        this.axios.get('/companies/' + company.id).then(res => {
          this.company = res.data;
        })
      },

      postAllComments() {
        this.comments = [];
        this.steps.forEach((step, index) => {
          this.postCommentsForStep(step);
        });
        this.comments.forEach(comment => {
          this.postSingleComment(comment)
        })
      },
      postCommentsForStep(step) {
        for (let key in step.order) {
          this.postCommentsForSubcategory(step.order[key])
        }
      },
      postCommentsForSubcategory(subcategory) {
        if (subcategory.comment && typeof subcategory.comment !== 'undefined') {
          this.comments.push({
            text: subcategory.comment,
            userid: store.getters.getUserId,
            submissionid: this.$route.params.id,
            subcategoryid: subcategory.id,
          })
        }
      },
      postSingleComment(comment) {
        let filters = '';
        filters += `?subcategoryid=${comment.subcategoryid}`;
        filters += `&userid=${comment.userid}`;
        filters += `&submissionid=${comment.submissionid}`;
       // console.log('get', filters);
        this.axios.get(`/comments${filters}`).then(r => {
          // console.log('getting comment', r);
          if (r.data.length) {
            this.axios.put('/comments/' + r.data[0].id, comment).then(r => {
            });
          } else {
            this.axios.post('/comments', comment).then(r => {
            });
          }
        });
      },


      loadComments() {
        const comments = [];
        for (let answerKey in this.lastSubmitted.answers) {
          if (this.lastSubmitted.answers[answerKey].comment) {
            comments.push(this.lastSubmitted.answers[answerKey].comment)
          }
        }
        this.comments = comments;
      },
      async loadSubmissionData() {
        let submissionData = await this.getVitaminData('submitted');
      //  console.log('submissiondata', submissionData);
        store.commit('setVitaminData', [submissionData, 'submitted']);
        store.commit('setSubmittedAnswers', submissionData.data.answers);
        this.lastSubmitted = submissionData.data;
        this.getSubscores(submissionData.data, 'submitted');
        this.loadComments();
      },
      async loadPreviousData() {
        let prevData = await this.getPreviousVitamin(this.$route.params.id, this.$route.params.uid);
        store.commit('setVitaminData', [prevData, 'previous']);
        store.commit('setPreviousAnswers', prevData.data.answers);
        this.lastReviewed = prevData.data;
        this.getSubscores(prevData.data, 'reviewed')
      },
      submitReview() {
        this.axios.put('/users/me', {
          lastreviewed: new Date()
        });
        this.axios.put('/submissions/' + this.lastSubmitted.id, {
          status: 'reviewed',
          reviewed: new Date()
        }).then(res => {
          this.logActivity('Reviewed submission', 'info (User)');
          this.$router.push('/evolution');
          this.postAllComments();
        })
      },

      async getVitaminId(type) {
        let id = '';
        let data = await this.axios.get('/submissions?status_ne=draft&_sort=finalized:DESC&_limit=1');
        if (data.data) {
          id = data.data[0].id
        }
        return id;
      },

      async getVitaminData(type) {
        let id = await this.getVitaminId(type);
        let request = '/submissions/' + id; //show last finalized, unless reviewing the last finalized, in that case show the one before that
        if (type !== 'previous') {
          request = '/submissions/' + this.$route.params.id;
        }
        return await this.axios.get(request);
      },
      fillSteps(steps) {
        let stepArr = [];
        for (let key in steps) {
          steps[key].id = key;
          stepArr.push(steps[key]);
        }
        this.steps = stepArr;
      },
      togglePrevious() {
        this.showPrevious = !this.showPrevious;
      },
    },

  }
</script>

<style scoped>
  .comment-icon.plus {
    height: 25px;
    display: block;
    border: 1px solid gray;
    border-radius: 50%;
    width: 25px;
    padding: 2px;
  }

  .small-circle-score {
    position: absolute;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);
    display: block;
    font-size: 39px;
  }
</style>



// WEBPACK FOOTER //
// src/components/Review/Review.vue